import type { ReactNode } from "react";

type IContentSectionDescriptionLineProps = {
  description?: string;
  children?: ReactNode;
};

function ContentSectionDescriptionLine({ description, children }: IContentSectionDescriptionLineProps) {
  if (!description && !children) {
    throw new Error("You must either specify a `description` or `children`");
  }

  return (
    <div className="flex max-w-xs items-center truncate sm:max-w-full">
      <p className="space-x-1 truncate font-aeonik text-sm font-medium tracking-wide text-slate-500">
        {description || children}
      </p>
    </div>
  );
}

export default ContentSectionDescriptionLine;
